@if (label()) {
  <p class="schedule-strip-label">{{ label() }}</p>
}
<dl class="schedule-strip">
  @for (item of items(); track item.term) {
    <div class="schedule-strip-item" grooveSurface variant="bordered" size="md">
      <dt class="schedule-strip-term">{{ item.term }}</dt>
      <dd class="schedule-strip-detail">{{ item.detail }}</dd>
    </div>
  }
</dl>
